/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { combineReducers } from 'redux';
import addHours from 'date-fns/add_hours';
import setMinutes from 'date-fns/set_minutes';
import { types } from '../actions/roadtest';

const defaultState = {
  from: setMinutes(new Date(), 0),
  to: setMinutes(addHours(new Date(), 1), 0),
  by: 'hour',
};

const defaultColor = {
  green: { min: '0', max: '30' },
  yellow: { min: '-5', max: '0' },
  red: { min: '-10', max: '-5' },
  type: 'snr',
};

const getTimes = (state = defaultState, action) => {
  const { type, payload } = action;
  if (type === types.getTimes) {
    return payload;
  }
  return state;
};

const getDevice = (state = [], action) => {
  const { type, payload } = action;
  if (type === types.getDevice) {
    return payload;
  }
  return state;
};

const getGateway = (state = [], action) => {
  const { type, payload } = action;
  if (type === types.getGateway) {
    return payload;
  }
  return state;
};

const getGpsColor = (state = defaultColor, action) => {
  const { type, payload } = action;
  if (type === types.getGpsColor) {
    return payload;
  }
  return state;
};

const getRadius = (state = 1, action) => {
  const { type, payload } = action;
  if (type === types.getRadius) {
    return payload;
  }
  return state;
};

const updateGps = (state = 0, action) => {
  const { type, payload } = action;
  if (type === types.updateGps) {
    return payload;
  }
  return state;
};

const startDwnld = (state = 0, action) => {
  const { type, payload } = action;
  if (type === types.startDwnld) {
    return payload;
  }
  return state;
};

export default combineReducers({
  getTimes,
  getDevice,
  getGateway,
  getGpsColor,
  getRadius,
  updateGps,
  startDwnld,
});




// WEBPACK FOOTER //
// ./src/redux/reducers/roadtest.js